'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Select, SelectItem, Avatar, Chip } from '@heroui/react';
import { ChainType } from '@/constants/chain-specific';
import { chainAggregators } from '@/constants/chain-specific/aggregators';
import { DEX_LIST } from '@/constants/project-specific/farms/dex';
import { Icon } from '@iconify/react';
interface DexOption {
  slug: string;
  name: string;
  logo: string;
  versions: ('v2' | 'v3' | 'v4' | 'velodrome')[];
  status: 'active' | 'rugged' | 'primary' | 'deprecated';
}
interface DexSelectorProps {
  chainId?: ChainType;
  selectedDex: string;
  onDexChange: (dexSlug: string) => void;
  className?: string;
}
export function DexSelector(t0) {
  const $ = _c(33);
  const {
    chainId: t1,
    selectedDex,
    onDexChange,
    className
  } = t0;
  const chainId = t1 === undefined ? 109 : t1;
  let t2;
  bb0: {
    const aggregatorData = chainAggregators[chainId];
    if (!aggregatorData?.adapters) {
      let t3;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[0] = t3;
      } else {
        t3 = $[0];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[1] !== aggregatorData.adapters) {
      const dexOptions = [];
      for (const [adapterAddress, adapterInfo] of Object.entries(aggregatorData.adapters)) {
        const dexSlug = adapterInfo.metadata.slug;
        const dexInfo = DEX_LIST[dexSlug];
        if (!dexInfo) {
          continue;
        }
        if (dexInfo.type === "v3") {
          continue;
        }
        const versions = [];
        if (dexInfo.type === "velodrome") {
          versions.push("velodrome");
        } else {
          if (dexInfo.type === "v2") {
            versions.push("v2");
          }
        }
        if (dexInfo.type === "v4") {
          versions.push("v4");
        }
        if (!dexInfo.type) {
          versions.push("v2");
        }
        if (versions.length === 0) {
          continue;
        }
        dexOptions.push({
          slug: dexSlug,
          name: dexInfo.name,
          logo: dexInfo.logo || "/images/dex/default.png",
          versions,
          status: dexInfo.status || "active"
        });
      }
      t3 = dexOptions.sort(_temp);
      $[1] = aggregatorData.adapters;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    t2 = t3;
  }
  const availableDexs = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label className="block text-sm font-medium mb-2">Select DEX Protocol</label>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== selectedDex) {
    t4 = selectedDex ? [selectedDex] : [];
    $[4] = selectedDex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onDexChange) {
    t5 = keys => {
      const key = Array.from(keys)[0] as string;
      if (key) {
        onDexChange(key);
      }
    };
    $[6] = onDexChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== availableDexs || $[9] !== selectedDex) {
    t6 = availableDexs.find(dex => dex.slug === selectedDex)?.logo;
    $[8] = availableDexs;
    $[9] = selectedDex;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Avatar src={t6} alt="DEX" size="sm" className="flex-shrink-0" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      trigger: "min-h-12",
      base: "w-full"
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== availableDexs || $[15] !== selectedDex) {
    bb1: {
      let t10;
      if ($[17] !== selectedDex) {
        t10 = dex_0 => dex_0.slug === selectedDex;
        $[17] = selectedDex;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      const selected = availableDexs.find(t10);
      const version = selected?.versions?.[0];
      if (!version) {
        t9 = null;
        break bb1;
      }
      t9 = <Chip key={version} size="sm" variant="flat" color={version === "v3" ? "primary" : version === "v4" ? "success" : version === "velodrome" ? "warning" : "secondary"} className="text-xs px-1 h-4">{version.toUpperCase()}</Chip>;
    }
    $[14] = availableDexs;
    $[15] = selectedDex;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[19] !== availableDexs) {
    t10 = availableDexs.map(_temp3);
    $[19] = availableDexs;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t5 || $[24] !== t7 || $[25] !== t9) {
    t11 = <Select placeholder="Choose a DEX to provide liquidity" selectedKeys={t4} onSelectionChange={t5} startContent={t7} classNames={t8} endContent={t9}>{t10}</Select>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== availableDexs.length) {
    t12 = availableDexs.length === 0 && <div className="text-center py-6 text-default-500"><p>No DEX protocols available for this chain</p></div>;
    $[27] = availableDexs.length;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== className || $[30] !== t11 || $[31] !== t12) {
    t13 = <div className={className}>{t3}{t11}{t12}</div>;
    $[29] = className;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
function _temp3(dex_1) {
  return <SelectItem key={dex_1.slug} textValue={dex_1.name} classNames={{
    base: "py-3"
  }}><div className="flex items-center justify-between w-full"><div className="flex items-center gap-3"><Avatar src={dex_1.logo} size="sm" className="flex-shrink-0" /><div><div className="font-semibold">{dex_1.name}</div><div className="text-xs text-default-500 flex items-center gap-1">{dex_1.versions.map(_temp2)}</div></div></div><div className="text-right text-xs"><Chip size="sm" color={dex_1.status === "rugged" ? "danger" : dex_1.status === "primary" ? "primary" : dex_1.status === "deprecated" ? "secondary" : "default"} variant="flat"><div className="flex items-center gap-1"><Icon icon={dex_1.status === "rugged" ? "famicons:skull-sharp" : dex_1.status === "primary" ? "fluent-emoji-flat:sports-medal" : "streamline-ultimate-color:check"} width="15px" height="15px" />{dex_1.status.toUpperCase()}</div></Chip></div></div></SelectItem>;
}
function _temp2(version_0) {
  return <Chip key={version_0} size="sm" variant="flat" color={version_0 === "v3" ? "primary" : version_0 === "v4" ? "success" : version_0 === "velodrome" ? "warning" : "secondary"} className="text-xs px-1 h-4">{version_0.toUpperCase()}</Chip>;
}
function _temp(a, b) {
  if (a.status === "rugged" && b.status !== "rugged") {
    return 1;
  }
  if (a.status !== "rugged" && b.status === "rugged") {
    return -1;
  }
  return a.name.localeCompare(b.name);
}